export default "__VITE_ASSET__86d5abfa__"